
const newNotification = async (notification: INotification) => {
    try {
        const notificationStore = useNotificationStore()
        notification.created = new Date()
        notification.is_temp = true
        notificationStore.newNotification(notification)
    } catch (error) {
        console.error(error)
    }
}

const remove_notification = async (notification: INotification) => {
    try {
        const notificationStore = useNotificationStore()
        notificationStore.notifications = notificationStore.notifications.filter(item => item !== notification)
    } catch (e) {
        console.error(e)
    }
}

export default function () {
    return { newNotification, remove_notification }
}
